import { render, staticRenderFns } from "./TeacherSection2.vue?vue&type=template&id=c0d81a48&"
import script from "./TeacherSection2.vue?vue&type=script&lang=js&"
export * from "./TeacherSection2.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSection2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports